import { render, staticRenderFns } from "./ProfileNotes.vue?vue&type=template&id=a945040e"
import script from "./ProfileNotes.vue?vue&type=script&lang=js"
export * from "./ProfileNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports